import { createFromIconfontCN } from '@ant-design/icons'

const IconFont = createFromIconfontCN({
  scriptUrl: [
    'https://at.alicdn.com/t/c/font_3255284_fyq3yn1r2eh.js', // lanxi-hm5-colorable
    'https://at.alicdn.com/t/c/font_2245097_ep9votyqnud.js', // lanxi-mobile-colorable
    'https://at.alicdn.com/t/font_2162808_of0ui0p7uc.js',
    'https://at.alicdn.com/t/c/font_2596689_721rnpthrgv.js', // Lanxi_HM5
    'https://at.alicdn.com/t/c/font_2999689_d66mixqqtc.js',
  ],
})

export default IconFont
